<template>
  <div class="space-y-8">
    <!-- Company Details Card -->
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <div class="px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-gray-100">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-3">
            <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-5 h-5 text-gray-600">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
    />
</svg>

            <h3 class="text-lg font-semibold text-gray-900">
              {{ $t('ProjectSettings.CompanyTab.header.details') }}
            </h3>
          </div>

          <button
            type="submit"
            class="btn btn--primary-blue flex items-center space-x-2"
            data-test="save-company"
            @click="updateCompany"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
  <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
</svg>

            <span>{{ $t('ProjectSettings.CompanyTab.button.saveSettings') }}</span>
          </button>
        </div>
      </div>

      <div class="p-6">
        <form
          class="space-y-8"
          @submit.prevent="updateCompany"
        >
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <!-- Company Information -->
            <div class="space-y-6">
              <div>
                <h4 class="text-sm font-medium text-gray-900 mb-4 flex items-center space-x-2">
                  <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4 text-gray-500">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
    />
</svg>

                  <span>{{ $t('ProjectSettings.CompanyTab.label.companyDetails') }}</span>
                </h4>

                <div class="space-y-4">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                      {{ $t('ProjectSettings.CompanyTab.label.name') }}
                    </label>

                    <AppInput
                      v-model="companyForm.form.name"
                      name="name"
                      type="text"
                      data-test="name"
                      class="form-input"
                    />
                  </div>

                  <div>
                    <label for="business_role">
                      Business Role
                    </label>

                    <AppInput
                      v-model="companyForm.form.business_role"
                      name="business_role"
                      type="text"
                      data-test="business_role"
                      class="form-input"
                    />
                  </div>

                  <div class="grid grid-cols-2 gap-4">
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-2">
                        {{ $t('ProjectSettings.CompanyTab.label.acn') }}
                      </label>

                      <AppInput
                        v-model="companyForm.form.acn"
                        name="acn"
                        type="text"
                        data-test="acn"
                        class="form-input"
                      />
                    </div>

                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-2">
                        {{ $t('ProjectSettings.CompanyTab.label.abn') }}
                      </label>

                      <AppInput
                        v-model="companyForm.form.abn"
                        name="abn"
                        type="text"
                        data-test="abn"
                        class="form-input"
                      />
                    </div>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                      {{ $t('ProjectSettings.CompanyTab.label.officeAddress') }}
                    </label>

                    <AppInput
                      v-model="companyForm.form.office_address"
                      name="office_address"
                      type="text"
                      data-test="office_address"
                      class="form-input"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- Contact Information -->
            <div class="space-y-6">
              <div>
                <h4 class="text-sm font-medium text-gray-900 mb-4 flex items-center space-x-2">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 text-gray-500">
  <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
</svg>

                  <span>{{ $t('ProjectSettings.CompanyTab.label.primaryContact') }}</span>
                </h4>

                <div class="space-y-4">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                      {{ $t('ProjectSettings.CompanyTab.label.contactName') }}
                    </label>

                    <AppInput
                      v-model="companyForm.form.contact_name"
                      name="contact_name"
                      type="text"
                      data-test="contact_name"
                      class="form-input"
                    />
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                      {{ $t('ProjectSettings.CompanyTab.label.contactPhone') }}
                    </label>

                    <AppInput
                      v-model="companyForm.form.contact_phone"
                      name="contact_phone"
                      type="text"
                      data-test="contact_phone"
                      class="form-input"
                    />
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                      {{ $t('ProjectSettings.CompanyTab.label.contactEmail') }}
                    </label>

                    <AppInput
                      v-model="companyForm.form.contact_email"
                      name="contact_email"
                      type="email"
                      data-test="contact_email"
                      class="form-input"
                    />
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                      {{ $t('ProjectSettings.CompanyTab.label.generalNoticesEmail') }}
                    </label>

                    <AppInput
                      v-model="companyForm.form.general_notices_email"
                      name="general_notices_email"
                      type="email"
                      data-test="general_notices_email"
                      class="form-input"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Company Logo Card -->
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <div class="px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-gray-100">
        <div class="flex items-center space-x-3">
          <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-5 h-5 text-gray-600">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
    />
</svg>

          <h3 class="text-lg font-semibold text-gray-900">
            {{ $t('ProjectSettings.CompanyTab.logo.title') }}
          </h3>

          <AppInfoHover :tooltip="$t('ProjectSettings.CompanyTab.logo.tooltip')" />
        </div>
      </div>

      <div class="p-6">
        <div class="max-w-md mx-auto">
          <div class="text-center">
            <div class="mb-6">
              <FileUpload
                v-model="fileUploadForm"
                accept="image/jpeg,image/png"
                @change="fileUploaded"
              />
            </div>

            <div
              v-if="logoMedia.mediaCollection.value.length > 0"
              class="mt-6"
            >
              <MediaDisplay
                :media="logoMedia.mediaCollection.value[0]"
                class="max-w-xs mx-auto"
                @delete="logoMedia.removeMedia($event.uuid)"
              />
            </div>

            <div
              v-else
              class="text-center py-8"
            >
              <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="mx-auto h-12 w-12 text-gray-400">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
    />
</svg>

              <h3 class="mt-2 text-sm font-medium text-gray-900">
                No logo uploaded
              </h3>

              <p class="mt-1 text-sm text-gray-500">
                Upload a company logo to be used in reports.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex w-full gap-4">
      <CompanySupplierList
        :company-id="$props.companyId"
        class="w-full"
      />
    </div>

    <div class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden p-6">
      <ProjectGroupsTab :company-id="$props.companyId" />
    </div>
  </div>
</template>

<script setup lang="ts">
import FileUpload from '@/components/FileUpload.vue';
import MediaDisplay from '@/components/MediaDisplay.vue';
import ProjectGroupsTab from '@/components/ProjectSettings/CompanyTab/ProjectGroupsTab.vue';
import { useFormData } from '@/composables/useFormData';
import { useMediaCollection } from '@/composables/useMediaCollection';
import { useStoreApiAction } from '@/composables/useStoreApiAction';
import { t } from '@/i18n';
import { useCompaniesStore } from '@/store/companies';
import Swal from 'sweetalert2';
import { computed, ref, watch } from 'vue';
import CompanySupplierList from './CompanySupplierList.vue';

const props = defineProps<{
  companyId: number;
}>();

const emits = defineEmits<{
  (e: 'dirty');
  (e: 'saved');
}>();

const companiesStore = useCompaniesStore();

const company = computed(() => {
  return companiesStore.models.query().with('projects').find(props.companyId);
});

const companyForm = useFormData({
  name: '',
  acn: '',
  abn: '',
  office_address: '',
  contact_name: '',
  contact_phone: '',
  contact_email: '',
  general_notices_email: '',
  business_role: '',
}, true);

watch(company, (newValue) => {
  if(newValue) {
    companyForm.setData(newValue);
    companyForm.resetDirtyStatus();
  }
}, { immediate: true });

watch(companyForm.isDirty, (newValue) => {
  if(newValue) {
    emits('dirty');
  } else {
    emits('saved');
  }
});

const updateCompanyAction = useStoreApiAction(companiesStore.updateCompany);

const updateCompany = () => {
  companyForm.resetErrors();

  updateCompanyAction.request(props.companyId, companyForm.form).then(() => {
    Swal.fire({
      title: t('ProjectSettings.CompanyTab.messages.companyUpdated'),
      icon: 'success',
    });

    companyForm.setData(company.value);
  }).catch((error) => {
    companyForm.setErrors(error.data);
  });
};

const logoMedia = useMediaCollection(companiesStore.showLogo);

watch(() => props.companyId, (newValue) => {
  if(newValue) {
    logoMedia.clear();
    logoMedia.fetchMedia(newValue);
  }
}, { immediate: true });

const storeMediaAction = useStoreApiAction(companiesStore.storeLogo);
const fileUploadForm = ref();

const fileUploaded = (event: Event) => {
  const files = Array.from((event.target as HTMLInputElement).files);
  const selectedFile = files[0];

  if(selectedFile) {
    const fileFormData = new FormData();

    fileFormData.append('images[]', selectedFile);

    storeMediaAction.request(company.value.id, fileFormData).then((medias) => {
      logoMedia.clear();
      logoMedia.addMedia(medias);
      fileUploadForm.value = [];
    }).catch((error) => {
      if(error.status === 422) {
        Swal.fire({
          icon: 'error',
          title: t('ProjectSettings.CompanyTab.messages.logoUploadFailed'),
          text: error.data.message,
        });
      }
    });
  }
};
</script>

<style scoped></style>
